export const caseStudies = [
  {
    id: 1,
    title: "Virtual Try-On for Leading Eyewear Brand",
    //client: "Lenskart (via Kiksar Solutions)",
    industry: "Fashion & Retail",
    challenge:
      "High product return rates due to sizing and fit issues in online eyewear purchases",
    solution:
      "Implemented AI-powered Virtual Try-On technology with real-time AR visualization and 3D modeling",
    results: [
      "45% reduction in product returns",
      "60% increase in online conversion rate",
      "Enhanced customer satisfaction scores",
      "Seamless integration with existing e-commerce platform",
    ],
    technologies: ["Computer Vision", "AR/VR", "3D Modeling", "Deep Learning"],
    image:
      "https://images.unsplash.com/photo-1574258495973-f010dfbb5371?w=800&q=80",
    testimonial:
      "IVIS LABS' Virtual Try-On solution has been a game-changer for our online business. The technology is seamless and our customers love it.",
  },
  {
    id: 2,
    title: "Predictive Maintenance for Manufacturing Plant",
    client: "Leading Automotive Manufacturer",
    industry: "Manufacturing",
    challenge:
      "Frequent unplanned machine downtime causing production delays and revenue loss",
    solution:
      "Deployed Machine Shop Monitor with IoT sensors for real-time monitoring and AI-powered predictive maintenance",
    results: [
      "40% reduction in unplanned downtime",
      "30% decrease in maintenance costs",
      "Real-time visibility into machine health",
      "Predictive alerts preventing critical failures",
    ],
    technologies: [
      "IoT",
      "Edge Computing",
      "Predictive AI",
      "Real-time Analytics",
    ],
    image:
      "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800&q=80",
    testimonial:
      "The predictive maintenance system has transformed our operations. We can now prevent failures before they happen.",
  },
  {
    id: 3,
    title: "Smart Campus Access Control System",
    client: "Premier Engineering College",
    industry: "Education",
    challenge:
      "Manual attendance tracking and security concerns with traditional entry-exit systems",
    solution:
      "Implemented automated Entry-Exit Tracking System with facial recognition and real-time analytics",
    results: [
      "100% automated attendance tracking",
      "Enhanced campus security",
      "Real-time visitor management",
      "Reduced administrative overhead by 70%",
    ],
    technologies: ["Computer Vision", "Facial Recognition", "IoT Integration"],
    image:
      "https://images.unsplash.com/photo-1562774053-701939374585?w=800&q=80",
    testimonial:
      "The system has streamlined our campus operations significantly. Security and attendance are now completely automated.",
  },
  {
    id: 4,
    title: "Visual Search Engine for E-commerce Platform",
    client: "Multi-category E-commerce Company",
    industry: "E-commerce",
    challenge:
      "Customers struggling to find products using text-based search, especially for visual items",
    solution:
      "Developed AI-powered Visual Search Engine enabling image-based product discovery",
    results: [
      "3x increase in product discovery rate",
      "50% improvement in search conversion",
      "Enhanced user experience",
      "Reduced search abandonment by 35%",
    ],
    technologies: ["Deep Learning", "Image Recognition", "Neural Networks"],
    image:
      "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80",
    testimonial:
      "Visual search has opened up a completely new way for our customers to discover products. It's been phenomenal.",
  },
];
